import React, { useState } from "react";
import axios from "axios";


const useBorrower = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, values }) => { },
}) => {
    const mainApi = '/koha/borrower'
    const [data, setData] = useState([])

    const getBorrowerData = (params) => {
        onBefore({
            axiosMode: "get", values: params
        })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data || [])
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postBorrowerData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(mainApi, data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                onFinish({
                    axiosMode: "post",
                    status: status === "success" ? "success" : "error",
                    values: responseData
                })
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchBorrowerData = (data) => {
        onBefore({
            axiosMode: "patch",
            values: data
        })
        axios.patch(mainApi, data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                onFinish({
                        axiosMode: "patch",
                        status: status === "success" ? "success" : "error",
                        values: responseData
                })
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteBorrowerData = (data) => {
        onBefore({
            axiosMode: "delete",
            values: data
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                onFinish({
                    axiosMode: "delete",
                    status: status === "success" ? "success" : "error",
                    values: responseData
                })
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        BorrowerData: data,
        getBorrowerData,
        postBorrowerData,
        patchBorrowerData,
        deleteBorrowerData,
    }
}
export { useBorrower }
